import { useEffect, useRef } from "react";
import { getCookieConsent } from "@/components/CookieConsent";

// Reuse the existing Clarity project. ID lives in the env config; falls back to
// the known project ID so tracking still works if the env var is missing.
const CLARITY_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || "ungmoqvwtp";

// Injects the Microsoft Clarity tag exactly once per browser session.
// Script URL is plain text on purpose: https://www.clarity.ms/tag/<project-id>
function loadClarity() {
  if (window.__clarityLoaded || !CLARITY_ID) return;
  window.__clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
}

// Loads Microsoft Clarity only after the visitor accepts the "Statistik" cookie
// (same consent solution as GA4). GA4 stays untouched. We never send PII through
// Clarity custom events or tags — sensitive DOM is masked via data-clarity-mask.
export default function Clarity() {
  const enabled = useRef(false);

  useEffect(() => {
    const enable = () => {
      if (enabled.current) return;
      enabled.current = true;
      loadClarity();
    };
    const c = getCookieConsent();
    // Auto-load if statistics was already accepted on an earlier visit.
    if (c && c.statistics) enable();
    const onConsent = (e) => { if (e.detail && e.detail.statistics) enable(); };
    window.addEventListener("cookie-consent-updated", onConsent);
    return () => window.removeEventListener("cookie-consent-updated", onConsent);
  }, []);

  return null;
}
